class Focus {
  constructor() {
    document.body.classList.remove("focus-outline")
    document.body.addEventListener("mousedown", e => {
      e.currentTarget.classList.remove("focus-outline")
    })

    document.body.addEventListener("keydown", e => {
      const keyCode = e.keyCode || e.which

      if (keyCode === 9 || keyCode === 27) {
        e.currentTarget.classList.add("focus-outline")
      }
    })

    // Indicate JS enabled
    document.body.classList.add("js")
  }
}

export default Focus
